import { createClient } from "@connectrpc/connect";
import { AuthRPCService } from "@cronika/proto/public/auth_pb";
import { CatalogRPCService } from "@cronika/proto/public/catalog_pb";
import { GeoRPCService } from "@cronika/proto/public/geo_pb";
import { UserRPCService } from "@cronika/proto/user/user_pb";
import { TradingRPCService } from "@cronika/proto/client/trading_pb";
import { PaymentsRPCService } from "@cronika/proto/client/payments_pb";
import { BonusesRPCService } from "@cronika/proto/client/bonuses_pb";
import { ChartRPCService } from "@cronika/proto/common/trading_pb";
import { CopyTradingRPCService } from "@cronika/proto/client/copy_trading_pb";
import { NotificationsRPCService } from "@cronika/proto/client/notifications_pb";
import { rpcTransport } from "./transport";

// Public services
export const authClient = createClient(AuthRPCService, rpcTransport);
export const catalogClient = createClient(CatalogRPCService, rpcTransport);
export const geoClient = createClient(GeoRPCService, rpcTransport);
export const chartClient = createClient(ChartRPCService, rpcTransport);

// User services
export const userClient = createClient(UserRPCService, rpcTransport);

// Client services
export const tradingClient = createClient(TradingRPCService, rpcTransport);
export const paymentsClient = createClient(PaymentsRPCService, rpcTransport);
export const bonusesClient = createClient(BonusesRPCService, rpcTransport);
export const copyTradingClient = createClient(CopyTradingRPCService, rpcTransport);
export const notificationsClient = createClient(NotificationsRPCService, rpcTransport);
